// extracted by mini-css-extract-plugin
export default {"root":"Mbpku","selected":"A_E77","image":"fXPHu","priceContainer":"pgJou","coinIcon":"zp1db"};